export default __webpack_public_path__ + "0d7c258307b738df2a228b09b85b6cee.png";